var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.088,
    height: 33.204,
    viewBox: "0 0 41.088 33.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(-1134.392 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(1134.392 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com",
    d: "M0,0H12.543V15.785H0V0M1.14,1.435V14.35H11.4V1.435Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(1148.664 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23-2",
    "data-name": "Group 23",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com-2",
    "data-name": "box-outer-light-all-svgrepo-com",
    d: "M0,0H12.543V15.785H0V0M1.14,1.435V14.35H11.4V1.435Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(1162.937 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23-3",
    "data-name": "Group 23",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com-3",
    "data-name": "box-outer-light-all-svgrepo-com",
    d: "M0,0H12.543V15.785H0V0M1.14,1.435V14.35H11.4V1.435Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(1134.392 401.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23-4",
    "data-name": "Group 23",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com-4",
    "data-name": "box-outer-light-all-svgrepo-com",
    d: "M0,0H12.543V15.785H0V0M1.14,1.435V14.35H11.4V1.435Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(1148.664 401.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23-5",
    "data-name": "Group 23",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com-5",
    "data-name": "box-outer-light-all-svgrepo-com",
    d: "M0,0H12.543V15.785H0V0M1.14,1.435V14.35H11.4V1.435Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(1162.937 401.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23-6",
    "data-name": "Group 23",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "box-outer-light-all-svgrepo-com-6",
    "data-name": "box-outer-light-all-svgrepo-com",
    d: "M0,0H12.543V15.785H0V0M1.14,1.435V14.35H11.4V1.435Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.8fdf3d7a32b057f41159ceeeb3981d91.svg";
export { ForwardRef as ReactComponent };